<template>
  <div>
    <div class="custom-radio">
      <label><input type="radio" v-model="exportOptions.language" value="1">
        выгружать кириллицу
      </label>
    </div>
    <div class="custom-radio">
      <label><input type="radio" v-model="exportOptions.language" value="2">
        выгружать английский
      </label>
    </div>
    <div class="form-group">
      <label><input type="checkbox" class="from-control" v-model="exportOptions.morions">
        экспортировать морионы (ID) препаратов
      </label>
    </div>
    <div class="form-group">
      <label><input type="checkbox" class="from-control" v-model="exportOptions.finance">
        экспортировать фин. часть (стоимость, сумма, себестоимость)
      </label>
    </div>
    <div class="form-group" v-if="extraOptions?.groupPrices">
      <label><input v-model="exportOptions.groupPrices" type="checkbox">
        Группировать препараты
      </label>
    </div>
    <div class="form-group" v-if="extraOptions?.validDates">
      <label><input v-model="exportOptions.validDates" type="checkbox">
        Выгружать сроки годности
      </label>
    </div>
    <div class="form-group" v-if="extraOptions?.invoiceNum">
      <label><input v-model="exportOptions.invoiceNum" type="checkbox">
        Выгружать номера накладных
      </label>
    </div>
    <div class="form-group" v-if="extraOptions?.priceQtyRate">
      <label><input v-model="exportOptions.priceQtyRate" type="checkbox">
        Учитывать коэфф. закупки и фасовку в блистерах
      </label>
    </div>
    <div class="form-group" v-if="extraOptions?.showDetailsExpireDates">
      <label><input v-model="exportOptions.showDetailsExpireDates" type="checkbox">
        Выгружать сроки годности препаратов в накладных
      </label>
    </div>
    <template v-if="extraOptions?.incomeByFact">
      <div class="custom-radio">
        <label><input type="radio" v-model="exportOptions.qtyByFact" value="0">
          выгружать закупочное количество препаратов
        </label>
      </div>
      <div class="custom-radio">
        <label><input type="radio" v-model="exportOptions.qtyByFact" value="1">
          выгружать фактическое количество препаратов
        </label>
      </div>
    </template>
    <template v-if="extraOptions?.expDatesSelected">
      <label>Был выбран фильтр по срокам годности</label>
      <div>
        <label><input type="radio" v-model="exportOptions.selectedRecordsOnly" :value="0">
          выгружать все позиции
        </label>
      </div>
      <div>
        <label><input type="radio" v-model="exportOptions.selectedRecordsOnly" :value="1">
          выгружать только отфильтрованные позиции
        </label>
      </div>
    </template>
    <slot/>

  </div>
</template>

<script>

export default {
  props: ['extraOptions'],
  data() {
    return {
      exportOptions: {
        finance: false,
        morions: false,
        validDates: false,
        invoiceNum: false,
        selectedRecordsOnly: 0,
        priceQtyRate: this.extraOptions?.priceQtyRate ?? false,
        language: 1,
        qtyByFact: 0,
      }
    }
  },
}

</script>

<style scoped>
.form-group {
  margin-bottom: 2px;
}
</style>
